import { createContext, useContext, ReactNode } from 'react';
import { useAdaptiveViewport, AdaptiveViewportState, DensityMode } from '@/hooks/useAdaptiveViewport';

const AdaptiveViewportContext = createContext<AdaptiveViewportState | undefined>(undefined);

export const AdaptiveViewportProvider = ({ children }: { children: ReactNode }) => {
  const viewport = useAdaptiveViewport();

  return (
    <AdaptiveViewportContext.Provider value={viewport}>
      {children}
    </AdaptiveViewportContext.Provider>
  );
};

export const useAdaptiveViewportContext = (): AdaptiveViewportState => {
  const context = useContext(AdaptiveViewportContext);
  if (!context) {
    throw new Error('useAdaptiveViewportContext must be used within AdaptiveViewportProvider');
  }
  return context;
};

// Safe hook that returns default values when used outside provider (e.g., in Portal/Dialog)
export const useSafeAdaptiveViewport = (): AdaptiveViewportState => {
  const context = useContext(AdaptiveViewportContext);
  return context ?? {
    availableHeight: typeof window !== 'undefined' ? window.innerHeight : 800,
    densityMode: 'normal' as DensityMode,
    isKeyboardOpen: false,
  };
};

export type { DensityMode };
